
///code for new layout css17jan2025
/* eslint-disable */

import React, { useEffect } from "react";
import "./Technician1.css";
import { Button } from "react-bootstrap";
import {  useNavigate } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import "../../AdminPages/AddDoctor/AddDoctor";
import "../../AdminPages/AddPatient/AddPatient";
import "../../AdminPages/AddTechnician/AddTechnician";
import "../../AdminPages/ViewAll/ViewAll";
import ChatNot from "../../components/Chat/ChatNot";
import "../../components/Chat/ChatNot.css";

function Technician() {
  var adminName1 = localStorage.getItem("adminName");
  console.log("ADMIN NAME ---", adminName1);

  const { logOut } = useUserAuth();
  const navigate = useNavigate();

  // Automatically redirect to ListOfPatients on load
  useEffect(() => {
    navigate("ListOfPatient"); // This navigates to the ListOfPatient route
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      {/* Sidebar */}
      <div className="techsidebar"></div>

      {/* Top Navigation */}
      <div className="top-nav">
        <h1
          style={{ fontSize: "24px", margin: 0, textDecoration: "underline" }}
        >
          WELCOME
        </h1>
        <Button
          variant="primary"
          onClick={handleLogout}
          className="logout-button"
        >
          <i className="fas fa-power-off logout-icon"></i>
        </Button>
      </div>

        <div>
          <ChatNot />
        </div>
      {/* </div> */}
    </>
  );
}

export default Technician;
